import styled from 'styled-components'
import theme from 'styles/theme'
// import { Flex } from 'rebass'
import { Container } from 'styles/sharedStyle'
import {
  Title60,
  Title42,
  Eyebrow,
  Body16,
  Body12,
} from 'components/Typography'

export const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  margin: ${theme.space[8]} auto;
  padding: 60px 20px 40px;
  background-color: ${(props) => props.theme.colors.boxBackground};

  ${theme.mediaQueries.large} {
    max-width: 1180px;
    padding: 80px;
  }
`

// +++++++++
// HEADING
// +++++++++

export const HeadingWrapper = styled(Container)`
  margin: 0 auto;
`

export const HeadingBenefits = styled(Title60)`
  font-family: 'Ernie'
  color: ${(props) => props.theme.colors.backgroundColor};
  margin-bottom: 20px;
  text-align: center;

  ${theme.mediaQueries.large} {
    margin-bottom: 40px;
  }
`

export const HeadingDescription = styled.div`
  text-align: center;
  margin-bottom: ${theme.space[6]};
  color: ${(props) => props.theme.colors.sagemediumToBlack};

  ${theme.mediaQueries.medium} {
    padding: 0 ${theme.space[12]};
  }
`

// +++++++++++++++
// LEVELS
// +++++++++++++++

export const AllLevelsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin: ${theme.space[4]} 0;
  cursor: pointer;
`

export const SingleLevelWrapper = styled.div`
  border-bottom-width: 5px;
  border-bottom-style: solid;
  border-bottom-color: ${(props) =>
    props.isActive ? props.color : 'transparent'};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: calc(100% / 3);
`

export const LevelHeadline = styled(Title42)`
  color: ${(props) =>
    props.isActive ? props.color : props.theme.colors.nonActive};
  margin-bottom: ${theme.space[1]};
`

export const LevelBandText = styled(Body12)`
  color: ${(props) =>
    props.isActive
      ? props.theme.colors.nonActive
      : props.theme.colors.nonActive};
  margin-bottom: ${theme.space[1]};
  padding: 0 2px;
  text-align: center;
  display: flex;
  align-items: center;
  min-height: 26px;

  ${theme.mediaQueries.small} {
    min-height: unset;
  }
`

export const LevelDot = styled.div`
  color: ${(props) =>
    props.isActive ? props.color : props.theme.colors.nonActive};
  margin-bottom: ${theme.space[1]};
`

// ++++++++++++++++++++++++++
// BENEFITS
// ++++++++++++++++++++++++++

export const BenefitsWrapper = styled.div`
  margin: ${theme.space[4]} 0;
`
export const SingleBenefitWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${theme.space[3]} 0 ${theme.space[4]} 0;
  border-bottom: 1px solid ${(props) => props.theme.colors.nonActive};
`
export const BenefitTitle = styled(Body16)``
export const DotsBox = styled.div`
  display: flex;
  flex-direction: row;
`

export const BenefitDot = styled.div`
  color: ${(props) =>
    props.isActive ? props.color : props.theme.colors.nonActive};
  margin: 0 ${theme.space[1]};

  ${theme.mediaQueries.medium} {
    margin: 0 ${theme.space[3]};
  }
`

export const TACText = styled(Eyebrow)`
  color: ${(props) => props.theme.colors.dark};
  margin-top: ${theme.space[4]};
`
